"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("app.scss"); // styles
require("vendor");
require("core");
require("templates-cache.generated"); // generated by grunt 'ngtemplates' task
require("apps");
var appConfig_1 = require("appConfig");
var body = angular.element('body');
body.ready(function () {
    // update config via config.js
    if (window.rincaConfig) {
        angular.merge(appConfig_1.appConfig, window.rincaConfig);
    }
    angular.module('rinca.config').constant('config', appConfig_1.appConfig);
    angular.module('rinca.config', ['ngDialog'])
        .constant('config', appConfig_1.appConfig)
        .config(['ngDialogProvider', function (ngDialogProvider) {
            ngDialogProvider.setDefaults({
                showClose: false,
                closeByDocument: true,
                closeByEscape: true
            });
        }]);
    /**
     * @ngdoc module
     * @name rinca-client
     * @packageName rinca-client
     * @description The root rinca module.
     */
    angular.bootstrap(body, [
        'rinca.config',
        'rinca.core',
        'rinca.apps',
    ].concat(appConfig_1.appConfig.apps || []), { strictDi: true });
    window['rincaIsReady'] = true;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/index.ts
// module id = 211
// module chunks = 0